/* eslint-disable react/jsx-props-no-spreading */
import {
  Redirect,
  Route as RouterRoute,
  RouteComponentProps,
} from 'react-router-dom'

import { msalInstance } from '../auth/config'
import { getEnvs } from '../utils/env'
import { locations } from '../utils/locations'
import type { Route } from './config'

const { bypassLogin } = getEnvs()

const loadRouteComponent = (
  props: RouteComponentProps<
    { [x: string]: string | undefined },
    object,
    unknown
  >,
  route: Route
) =>
  route.component &&
  route.template && (
    <route.template>
      <route.component {...props} />
    </route.template>
  )

const Routes = (route: Route): JSX.Element => {
  const account = msalInstance.getActiveAccount()
  const isAuthenticated = bypassLogin || !!account
  const { path, redirect, isPrivate } = route

  return (
    <RouterRoute
      path={path}
      render={(props) => {
        if (redirect) {
          return <Redirect to={redirect} />
        }

        if (path === locations.signIn) {
          return isAuthenticated ? (
            <Redirect to={locations.loggedInRedirect} />
          ) : (
            loadRouteComponent(props, route)
          )
        }

        if (!isPrivate) {
          return loadRouteComponent(props, route)
        }

        return isAuthenticated ? (
          loadRouteComponent(props, route)
        ) : (
          <Redirect to={locations.signIn} />
        )
      }}
    />
  )
}

export default Routes
